import { async } from 'regenerator-runtime';
import { MODEL_CLOSE_SEC } from './config.js';
import * as model from './model.js';
import recipeView from './views/recipeview.js';
import searchView from './views/searchView.js';
import resultsView from './views/resultsView.js';
import bookmarksView from './views/bookmarksView.js';
import paginationView from './views/paginationView.js';
import addRecipeView from './views/addRecipeView.js';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

// if(module.hot){
//   module.hot.accept();
// }

///////////////////////////////////////

const controlRecipes = async function(){
  try {
    const id = window.location.hash.slice(1);
    if (!id) return;
    //1) Render spinner 
    recipeView.renderSpinner();
    //0) Update results view to mark selected search results
    resultsView.update(model.getSearchResultsPage());
    bookmarksView.update(model.state.bookmarks);
    //1) Loading Recipe
    await model.loadRecipe(id);
    //2) rendering recipe
    recipeView.render(model.state.recipe);
    
  } catch (err){
    recipeView.renderError();
    console.error(err);
  }
};

const controlSearchResults = async function(){
  try {
    resultsView.renderSpinner();
    //1) Get search query
    const query = searchView.getQuery();
    if(!query) return;
    //2) Load search results
    await model.loadSearchResults(`${query}`);
    //3) Render results
    // resultsView.render(model.state.search.results);
    resultsView.render(model.getSearchResultsPage(1));
    //4)Render pagination buttons
    paginationView.render(model.state.search);
  } catch (error) {
    console.log(err);
  }
};

const controlPagination = function(goToPage){
    //3) Render new results
    // resultsView.render(model.state.search.results);
    resultsView.render(model.getSearchResultsPage(goToPage));
    //4)Render pagination buttons
    paginationView.render(model.state.search);
  };

  const controlServings = function(newServings){
    // 1) update the recipe servings (in state)
    model.updateServings(newServings);
    // 2) update the recipe view
    // recipeView.render(model.state.recipe);
    recipeView.update(model.state.recipe);
  };

const controlAddBookmark = function(recipe){
  // 1) add/remove bookmark
  if(!model.state.recipe.bookmarked) model.addBookmark(model.state.recipe);
  else model.deleteBookmark(model.state.recipe.id);

  // 2) update recipeview
  recipeView.update(model.state.recipe);

  //3) Renderbookmarks
  bookmarksView.render(model.state.bookmarks);
};

const controlBookmarks = function(){
  bookmarksView.render(model.state.bookmarks)
};

const controlAddRecipe = async function(newRecipe){
  try {
    //Show loading spinner
    addRecipeView.renderSpinner();
    //Upload the new Recipe data
    await model.uploadRecipe(newRecipe);
    console.log(model.state.recipe);
    //render Recipe
    recipeView.render(model.state.recipe);
    //Success message
    addRecipeView.renderMessage();
    //render bookmark view
    bookmarksView.render(model.state.bookmarks);
    //change id in url
    window.history.pushState(null, '', `#${model.state.recipe.id}`);
    // close form window
    setTimeout(function(){
      addRecipeView.toggleWindow();
    }, MODEL_CLOSE_SEC * 1000 );
  } catch (err) {
    console.error(`💥 WAH`, err);
    addRecipeView.renderError(err.message);
  }
};

const init = function(){
  bookmarksView.addHandlerRender(controlBookmarks);
  recipeView.addHandlerRender(controlRecipes);
  recipeView.addHandlerUpdateServings(controlServings);
  recipeView.addHandlerAddBookmark(controlAddBookmark);
  searchView.addHandlerSearch(controlSearchResults);
  paginationView.addHandlerClick(controlPagination);
  addRecipeView.addHandlerUpload(controlAddRecipe);
};

init();

